import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBillInvoices } from "../../../store/billInvoiceSlice";
import "../../../Styles/Common.css";          // already includes the basics

/* ────────────────────────────────────────────────────────────────────────── */
/*  Card used inside the grid – shows everything and can collapse / expand  */
/* ────────────────────────────────────────────────────────────────────────── */
const InvoiceCard = ({ inv }) => {
  const [open, setOpen] = useState(false);
  /** helper to format amounts  */
  const fmt = (n) =>
    (n ?? 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    /* ▸ 9 % CGST / SGST calculated from Sell‑Price (ictSellPrice) */
    const gstAmt=inv.ictSellPrice*inv.gstPer/100
  return (
    <div className="card invoice-card">
      <header className="invoiceSection">
        <h3 className="invoiceTabs">
            ITE YONIK SERVICES
            <p>Adda Mehatpur, Nakodar</p>
            <p>Jalandhar, Pb(144040), India</p>
        </h3>
        <p className="invoiceTabs">
            <i className="fa fa-phone"></i> +91-7719438825
            <br/>
            <i className="fa fa-envelope"></i> Info@iteyonikservice.com
        </p>
        <p className="invoiceTabs">
            Date: {new Date(inv.created).toLocaleDateString()} <br/>
            GSTIN: XYZ123123456890
        </p>
      </header>
      <header onClick={() => setOpen((o) => !o)}>
        <h3 className="invoiceTabs">
          Invoice #{inv.id} – {inv.ictName}{" "}
        </h3>
          <small className="invoiceTabs" style={{ fontWeight: 400 }}>
            [Training Card # {inv.tcId}]
          </small>
      </header>

      {open && (
        <div className="details">
          <section>
            <strong>Billed To</strong>
            <div className="invoiceSection">
                <p className="invoiceTabs">{inv.billedToPerson || "-"}</p>
                <p className="invoiceTabs">{inv.billedToOrg || "-"}</p>
                <p>{inv.clientContact} | {inv.clientEmail}</p>
            </div>
            <div className="invoiceSection">
                <p className="invoiceTabs">{inv.billedToAddress}</p>
                <p className="invoiceTabs">{inv.billedToState}</p>
                <p className="invoiceTabs">{inv.billedToCountry}</p>
            </div>
            <div className="invoiceSection">
                <p>GSTIN: {inv.clientGSTIN || "-"}</p>
            </div>
          </section>

          <section>
            <strong>Training</strong>
            <div className="invoiceSection">
                <p className="invoiceTabs">Trainer: {inv.trainerName || "-"}</p>
                <p className="invoiceTabs">Training/Course: {inv.ictName || "-"}</p>
                <p className="invoiceTabs">Training/Course: {inv.totalDuration || "-"}</p>
            </div>
            <div className="invoiceSection">
                <p className="invoiceTabs">
                Schedule <br/>
                {inv.batchStartDate} {inv.batchStartTime} &rarr;{" "}
                {inv.batchEndDate} {inv.batchEndTime}
                </p>
                <p className="invoiceTabs">
                    Location : {inv.location} <br/>  Study Mode : {inv.studyMode}
                </p>
                <p className="invoiceTabs">
                Training Type : <br/>{inv.isStandard} - {inv.isPublic}
                </p>
            </div>
          </section>
          <section>
            <table className="table">
            <strong>Cost Breakup</strong>
                <tr>
                    <td>Tour Cost</td>
                    <td>{fmt(inv.tourCost)}</td>
                </tr>
                <tr>
                    <td>Travel Cost</td>
                    <td>{fmt(inv.travelCost)}</td>
                </tr>
                <tr>
                    <td>Accommodation Cost</td>
                    <td>{fmt(inv.accommodationCost)}</td>
                </tr>
                <tr>
                    <td>DC Cost</td>
                    <td>{fmt(inv.dcCost)}</td>
                </tr>
                <tr>
                    <td>Misc Cost</td>
                    <td>{fmt(inv.miscCost)}</td>
                </tr>
                <tr>
                    <td>Trainer Cost</td>
                    <td>{fmt(inv.trainerCost)}</td>
                </tr>
                <tr>
                    <td>Total Expense</td>
                    <td>{fmt(inv.totalExpense)}</td>
                </tr>
                <hr/>
                <tr>
                    <td>MRP</td>
                    <td>{fmt(inv.ictMrp)}</td>
                </tr>
                <tr>
                    <td>Sell Price</td>
                    <td>{fmt(inv.ictSellPrice)}</td>
                </tr>
                <tr><td>CGST + SGST {fmt(inv.gstPer)}%</td><td>{fmt(gstAmt)}</td></tr>
                <hr/>
                <tr>
                    <td>Gross Revenue</td>
                    <td>{fmt(inv.grossRev)}</td>
                </tr>
                <tr>
                    <td>Net Revenue</td>
                    <td>{fmt(inv.netRev)}</td>
                </tr>
            </table>
          </section>
          <section className="invoiceSection">
            <div className="invoiceTabs">
              <span>GST/VAT %</span> <span>{fmt(inv.gstPer)}</span>
            </div>
            <div className="invoiceTabs">
              <span>Received Amt </span> <span>({inv.receivingCurrency || "INR"}){fmt(inv.receivingAmt)}</span>
            </div>
            <div className="invoiceTabs">
              <span>INR Converation Rate</span> <span>{fmt(inv.inrConvertRate)}</span>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

/* ────────────────────────────────────────────────────────────────────────── */
/*  MAIN PAGE                                                                */
/* ────────────────────────────────────────────────────────────────────────── */
export default function ICTInvoice() {
  const dispatch = useDispatch();

  const [searchType, setSearchType] = useState("tcId");
  const [query, setQuery] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const { data: invoices = [], loading, error } = useSelector(
    (s) => s.billInvoices
  );

  const filtered = invoices.filter((inv) => {
    if (!hasSearched) return false;
    const field = (inv[searchType] ?? "").toString().toLowerCase();
    return field.includes(query.trim().toLowerCase());
  });

  const handleSearch = () => {
    if (!query.trim()) return;
    dispatch(fetchBillInvoices())
      .unwrap()
      .then(() => setHasSearched(true));
  };

  const clearSearch = () => {
    setQuery("");
    setHasSearched(false);
  };

  return (
    <div className="invoice-page">
      <div className="search-toolbar">
        <select
          value={searchType}
          onChange={(e) => setSearchType(e.target.value)}
          className="filter-input"
        >
          <option value="tcId">Training Card ID</option>
          <option value="ictName">ICT Name</option>
          <option value="billedToPerson">Billed Person</option>
          <option value="billedToOrg">Billed Org</option>
        </select>

        <input
          className="filter-input"
          placeholder="Search…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />

        <button className="btn-primary" onClick={handleSearch}>
          Search
        </button>
        {hasSearched && (
          <button className="btn-secondary" onClick={clearSearch}>
            Clear
          </button>
        )}
      </div>

      {loading && <p style={{ textAlign: "center" }}>Loading…</p>}
      {error && <p className="error">{error}</p>}
      {hasSearched && filtered.length === 0 && !loading && (
        <p style={{ textAlign: "center" }}>No invoices match your query.</p>
      )}

      <div className="grid-container">
        {filtered.map((inv) => (
          <InvoiceCard key={inv.id} inv={inv} />
        ))}
      </div>
    </div>
  );
}
